import { observable } from 'mobx';

class MembershipStore {
    processing = observable.box(false); 
    alerts = observable([]);
    processingMessage = observable.box(''); 
    userSubscriptionsResultSet = observable.box(null);
    membershipsResultSet = observable.box(null);   
    multiCurrencyMode = false;
    defactoCurrency = null; 
    changeForm = observable.map({   
        membership: null,     
        payment_frequency: 'monthly',
        use_stored_cc: false,
        cc_number: '',
        cc_expiration_month: '',
        cc_expiration_year: '',
        cc_holder_name: '',
        payment_method: '',
    });  
    reloadData = observable.box(false);  
    changeFormErrors = observable.map({});
    changeFormProcessSuccess = observable.box(false);
    changeFormProcessError = observable.box(false);
    balance = null;
    storedCc = null;
    eligibleForTrial = false;   
    //trialEnabled = false; 
    creditCardChangeForm = observable.map({   
        cc_number: '',
        cc_expiration_month: '',
        cc_expiration_year: '',
        cc_holder_name: '',
        payment_method: '',
        /*
        cc_number: '4012888888881881',
        cc_expiration_month: '05',
        cc_expiration_year: '2026',
        cc_holder_name: 'Holdy Holderson',
        payment_method: 5,   
        */  
    });      
    creditCardChangeFormErrors = observable.map({});   
    creditCardChangeFormProcessSuccess = observable.box(false); 
    promoCode = observable.box('');
    promotionsResultSet = observable.box(null);
    promotionErrorMessage = observable.box(null);
    prmotionAppliedSuccessfully = observable.box(false);

    constructor(){         
        if (window.location.hostname === 'localhost') {        
            this.changeForm.set('cc_number', '4012888888881881');        
            this.changeForm.set('cc_expiration_month', '05');        
            this.changeForm.set('cc_expiration_year', '2026');
            this.changeForm.set('cc_holder_name', 'Holdy Holderson');               
            this.changeForm.set('payment_method', '5');
        }        
    }


    isTrialMode() {
        const currentMembership = this.getCurrentMembership(); 
        //return (this.trialEnabled && currentMembership.slug === 'free' && this.eligibleForTrial);
        return (currentMembership.slug === 'free' && this.eligibleForTrial);
    }

    getPromotion() {
        const promotionsSet = this.promotionsResultSet.get();
        if (!promotionsSet || promotionsSet.count === 0) {
            return null;
        }
        return promotionsSet.results[0];
    }

    getChangeFormSubtotal() {
        const membership = this.getMembershipBySlug(this.changeForm.get('membership'));
        if (this.changeForm.get('payment_frequency') === 'monthly') {
            //return membership.monthly_price;
            return this.getMonthlyPrice(membership).amount;
        }
        else if(this.changeForm.get('payment_frequency') === 'annual') {
            //return membership.annual_price; 
            return this.getAnnualPrice(membership).amount;
        }
        return null;
    }

    getChangeFormTotal() {  
        let subtotal = this.getChangeFormSubtotal();
        const promotion = this.getPromotion();  
        if (!promotion) {
            return subtotal;
        }
        const membership = this.getMembershipBySlug(this.changeForm.get('membership'));
        subtotal = this.getMonthlyPrice(membership).amount;
        return (subtotal * (1 - promotion.discount_percent/100)).toFixed(2);
    }

    getMembershipBySlug(slug) {   
        return this.membershipsResultSet.get().results.find(result => 
            result.slug === slug
        );       
    }

    getFreeMembership() {
        return this.getMembershipBySlug('free');
    }

    getMembershipPrice(membership, monthly) {
        let prices = membership.annual_prices;
        if (monthly) {
            prices = membership.monthly_prices;
        }
        return prices.find(price =>
            price.currency === this.defactoCurrency.code
        );
    }

    getDefactoPriceAmount(userSubscription) {
        const regularPrice = this.getMonthlyPrice(userSubscription.subscription.membership);
        let defactoAmount = regularPrice.amount;
        if (userSubscription.promotion) {
            defactoAmount = regularPrice.amount * (1 - userSubscription.promotion.discount_percent/100);
            defactoAmount = defactoAmount.toFixed(2);
        }
        return defactoAmount;
    }

    getDefactoPriceDisplay(userSubscription) {
        return `${this.defactoCurrency.code} ${this.defactoCurrency.symbol}${this.getDefactoPriceAmount(userSubscription)}`;
    }

    getAnnualPrice(membership) {
        return this.getMembershipPrice(membership, false);
    }    

    getMonthlyPrice(membership) {
        return this.getMembershipPrice(membership, true);
    }        

    mockFreeUserSubscription() {
        return {
            status: 'current',
            subscription: {
                membership: this.getFreeMembership(),
            }
        }
    }    
    
    getCurrentUserSubscription() {        
        const current = this.userSubscriptionsResultSet.get().results.find(result => 
            result.status === 'current'
        );
        if (!current) {            
            return this.mockFreeUserSubscription();
        }
        return current;
    }    
    
    getPendingUserSubscription() {        
        return this.userSubscriptionsResultSet.get().results.find(result => 
            result.status === 'pending'
        );
    }         

    getCurrentMembership() {
        return this.getCurrentUserSubscription().subscription.membership;
    }     

    getTargetMembership() {
        return this.membershipsResultSet.get().results.find(result => 
            result.slug === this.targetMembershipSlug
        );
    }

    isDataLoaded() {
        return (this.membershipsResultSet.get() && this.userSubscriptionsResultSet.get())
    }
}

let membershipStore = new MembershipStore();
export default membershipStore;


// WEBPACK FOOTER //
// ./src/stores/membershipStore.js